export default "/public/img/bailiwik.com.bcf63ed8.svg";